import { DraftPost } from '../../core';
import { EvalFormValue } from '../model/eval-form-value.model';

import { evaluationFormPostTransformer } from './evaluation-form-post.transformer';

export function draftPostTransformer(evalForm: EvalFormValue): DraftPost {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        draftId: evalForm.draftId,
        templateVersionId: evalForm.templateVersionId,
        ownerId: evalForm.userId,
        form: evaluationFormPostTransformer(evalForm),
    } as DraftPost;
}
